import { labelsApi } from "api/TenantSlug/Label/api";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";
import { LabelType } from "types/enums";

import LabelData = App.Data.LabelData;

interface UseCategorySelectOptionsParams {
    useNameAsValue?: boolean;
}

export const useCategorySelectOptions = ({ useNameAsValue = false }: UseCategorySelectOptionsParams = {}) => {
    return useSelectOptions<LabelData>({
        apiFunction: (payload) => labelsApi.index(payload),
        dataKey: "labels",
        cacheKey: `category-select-${useNameAsValue ? "name" : "id"}`,
        queryParams: {
            filter: {
                filter: {
                    type: LabelType.Category,
                },
            },
        },
        mapToOption: (label) => ({
            label: label.name,
            value: useNameAsValue ? label.name : label.id.toString(),
        }),
    });
};
